module.exports = __webpack_public_path__ + "static/media/section3@2x.d51001c7.png";